import React, { useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { GetClient, GetCompaniesList, GetCompany, PostPerformActivity } from '../services/httpServices';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import ActivitesHistory from './ActivitesHistory';
import styled from '@emotion/styled';
import ClientListForAssociation from './ClientListForAssociation';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function PerformActivity(props) {
  let { id, checkClient } = useParams();
  const navigate = useNavigate();

  const [saved, setSaved] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [message, setMessage] = useState('');
  const [companies, setCompanies] = useState([]);
  const [isAssociateEmployer, setIsAssociateEmployer] = useState('No');
  const [client, setClient] = useState({});
  const [company, setCompany] = useState({});
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedClients, setSelectedClients] = useState([]);

  const location = useLocation();
  const [ACTIVITIESLIST, setActivitiesList] = useState([]);
  const [tasks, setTasks] = useState([]);

  const activityTypeRef = useRef('');
  const activitiyDateRef = useRef('');
  const activityTimeRef = useRef('');
  const followUpDateRef = useRef('');
  const commentsRef = useRef('');
  const nextStageRef = useRef('');
  const detailsRef = useRef('');

  ///////////////////Refs for Tasks/////////////////////
  const activityNameRef = useRef('');
  const activityCommentsRef = useRef('');

  const fetchData = async (event) => {
    const savedCompanies = await GetCompaniesList();

    // const tasks = await GetTasksForClients(id);

    setCompanies(savedCompanies);
    // setTasks(tasks);

    if (checkClient == 'true') {
      let savedClient = await GetClient(id);
      //('client:', client);
      setClient(savedClient);

      setSelectedCompany(savedCompanies?.find((e) => e.id == savedClient?.companyId));
    } else {
      let savedCompany = await GetCompany(id);
      // console.log('company:', savedCompany);
      setCompany(savedCompany);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [location]);

  const PerformActivity = async (event) => {
    event.preventDefault();
    //console.log('llalalal', tasks);
    let associatedEmployer = [];
    if (selectedCompany != null) {
      associatedEmployer.push(selectedCompany?.id);
    }

    //console.log('editHit');
    setLoading(true);
    var payload = {};
    if (checkClient == 'true') {
      payload = {
        activityType: activityTypeRef.current.value,
        activityDate: activitiyDateRef.current.value,
        activityTime: activityTimeRef.current.value,
        followUpDate: followUpDateRef.current.value,
        comments: commentsRef.current.value,
        nextStage: nextStageRef.current.value,
        clientId: checkClient == 'true' ? id : null,
        companyIdList: associatedEmployer,
        clientIdList: [],
        details: detailsRef.current.value,
        subActivities: tasks,
      };
    } else {
      payload = {
        activityType: activityTypeRef.current.value,
        activityDate: activitiyDateRef.current.value,
        activityTime: activityTimeRef.current.value,
        followUpDate: followUpDateRef.current.value,
        comments: commentsRef.current.value,
        nextStage: nextStageRef.current.value,
        companyId: checkClient == 'false' ? id : null,
        companyIdList: [],
        clientIdList: selectedClients,
        subActivities: tasks,
      };
    }

    //console.log(payload);
    let response = await PostPerformActivity(payload);
    //console.log('PostResponse:', response);
    if (response.status == 200) {
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeIsAssociateEmployer = (event) => {
    setIsAssociateEmployer(event.target.value);
  };
  //console.log('selectedCompany:', selectedCompany);
  // console.log(
  //   'CCC0:',
  //   companies?.find((e) => e.id == client?.companyId)
  // );
  const onAddTaskBtnClick = (event) => {
    event.preventDefault();
    let task = {
      id: 0,
      activityName: activityNameRef.current.value,
      comments: activityCommentsRef.current.value,
      deptId: selectedDepartment?.key,
    };
    let savedTasks = tasks;
    savedTasks.push(task);
    setTasks(savedTasks);
    //console.log('savedTasks:', savedTasks);
  };
  //console.log('Tasks:', tasks);

  const currentDate = new Date();
  const currentHour = currentDate.getHours().toString().padStart(2, '0');
  const currentMinute = currentDate.getMinutes().toString().padStart(2, '0');
  const currentTime = `${currentHour}:${currentMinute}:00`;

  const currentYear = currentDate.getFullYear().toString();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // add 1 to get the correct month
  const currentDay = currentDate.getDate().toString().padStart(2, '0');
  const currentDateStr = `${currentYear}-${currentMonth}-${currentDay}`;
  return (
    <>
      <Helmet>
        <title> Perform Activity | Immigration System </title>
      </Helmet>

      <Container>
        <form onSubmit={PerformActivity}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Perform Activity for{' '}
              <span style={{ color: '#ad1f22' }}>
                {checkClient == 'true' ? client?.fullName : company?.companyName}
              </span>
            </Typography>

            {/* <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}> */}

            <Stack direction="row" spacing={2}>
              {/* <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button> */}
              <Button type="submit" variant="contained">
                Save
              </Button>
            </Stack>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Activity Type"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={activityTypeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Activity Date"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        type="date"
                        disabled
                        defaultValue={currentDateStr}
                        InputLabelProps={{ shrink: true }}
                        inputRef={activitiyDateRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Activity Time"
                        required
                        disabled
                        type="time"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={currentTime}
                        InputLabelProps={{ shrink: true }}
                        inputRef={activityTimeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Follow Up Date"
                        variant="outlined"
                        fullWidth
                        required
                        size="small"
                        type="date"
                        // defaultValue={user.userEmail}
                        inputRef={followUpDateRef}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Comments"
                        variant="outlined"
                        fullWidth
                        size="small"
                        // defaultValue={user.userEmail}
                        inputRef={commentsRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Next Stage"
                        variant="outlined"
                        fullWidth
                        size="small"
                        // defaultValue={user.userEmail}
                        inputRef={nextStageRef}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}

          {/* <TasksList setTasks={setTasks} loading={loading} /> */}
          {/* ) : null} */}
          {/* {tasksList} */}

          {/* Associate Clients */}
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} marginTop={4}>
            <Typography variant="h4" gutterBottom>
              Associate Client with Employer
            </Typography>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : checkClient == 'true' ? (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={4}>
                      <FormControl>
                        <FormLabel id="demo-controlled-radio-buttons-group">
                          Do you want to Associate or Change Employer?
                        </FormLabel>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={isAssociateEmployer}
                          onChange={handleChangeIsAssociateEmployer}
                          row
                        >
                          {client.companyId != null ? (
                            <FormControlLabel value="Yes" control={<Radio />} label="Change" />
                          ) : (
                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          )}

                          <FormControlLabel value="No" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid direction="column" item xs={12} sm={4} md={4}>
                      <FormControl>
                        <FormLabel id="demo-controlled-radio-buttons-group">If yes please select Employer :</FormLabel>
                      </FormControl>
                      <Item>
                        <Autocomplete
                          id="role"
                          size="small"
                          options={companies}
                          disabled={isAssociateEmployer == 'No' ? true : false}
                          defaultValue={companies?.find((e) => e.id == client?.companyId)}
                          getOptionLabel={(company) => company.companyName}
                          renderInput={(params) => (
                            <TextField required {...params} label="Select Employer" variant="outlined" />
                          )}
                          onChange={(event, company) => setSelectedCompany(company)}
                        />
                      </Item>
                      <Item hidden={isAssociateEmployer == 'No' ? true : false}>
                        <TextField
                          label="Details for Changing Employer"
                          variant="outlined"
                          fullWidth
                          size="small"
                          inputRef={detailsRef}
                        />
                      </Item>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <ClientListForAssociation companies={companies} setSelected={setSelectedClients} />
          )}
        </form>
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>

      <ActivitesHistory setActivitiesList={setActivitiesList} />
    </>
  );
}
